import React from 'react';
import { TextRow } from 'components';

export const TIMESHEET_ENUMS = {
    FIXED: 'FIXED',
    PAYCODE: 'PAYCODE',
};

export const statusFilterEnums = {
    ALL: 'ALL',
    COMPLIANT: 'COMPLIANT',
    NON_COMPLIANT: 'NON_COMPLIANT',
};

export const statusFilterTypes = [
    { title: 'All', tabValue: statusFilterEnums.ALL },
    { title: 'Compliant', tabValue: statusFilterEnums.COMPLIANT },
    { title: 'Non-Compliant', tabValue: statusFilterEnums.NON_COMPLIANT },
];

const getPercentColor = (percent, minPercent) => {
    if (percent >= minPercent) return '#00C851';
    if (percent >= minPercent * 0.7) return '#FFB400';
    return '#FF4444';
};

const getComplianceChip = (isCompliant) => {
    if (isCompliant) {
        return <span className="compliance-chip compliant">Compliant</span>;
    }
    return <span className="compliance-chip non-compliant">Non-Compliant</span>;
};

export const summaryHead = [
    { name: 'fullName', title: 'Full Name', custom: false, width: '180px' },
    { name: 'serviceHours', title: 'Service Hours', iconType: 'date', width: '120px' },
    { name: 'supervisionHoursReceived', title: 'Supervision Hours', iconType: 'date', width: '140px' },
    { name: 'supervisionPercent', title: 'Percent', iconType: 'date', width: '90px' },
    { name: 'contactsCount', title: 'Contacts', iconType: 'date', width: '90px' },
    { name: 'supervisors', title: 'Supervisors', custom: false, width: '160px' },
    { name: 'isCompliant', title: 'Status', custom: false, width: '120px' },
];

export const summaryBody = [
    {
        rowText: (item) => (
            <div className="info-and-avatar">
                <div className="avatar-box">
                    {item?.staff?.avatar?.url ? (
                        <img src={item.staff.avatar.url} alt="" />
                    ) : (
                        `${item?.staff?.firstName?.slice(0, 1) || ''}${item?.staff?.lastName?.slice(0, 1) || ''}`
                    )}
                </div>
                <TextRow name={`${item?.staff?.firstName || ''} ${item?.staff?.lastName || ''}`} textWidth={8} />
            </div>
        ),
    },
    {
        rowText: (item) => <p>{item?.serviceHours?.toFixed(1)}h</p>,
    },
    {
        rowText: (item) => <p>{item?.supervisionHoursReceived?.toFixed(1)}h</p>,
    },
    {
        rowText: (item) => (
            <p style={{ color: getPercentColor(item?.supervisionPercent, item?.config?.minPercent || 5), fontWeight: 700 }}>
                {item?.supervisionPercent?.toFixed(1)}%
            </p>
        ),
    },
    {
        rowText: (item) => {
            const min = item?.config?.minContactsPerMonth || 2;
            const count = item?.contactsCount || 0;
            return (
                <p style={{ color: count >= min ? '#00C851' : '#FF4444', fontWeight: 600 }}>
                    {count}/{min}
                </p>
            );
        },
    },
    {
        rowText: (item) => {
            const supervisors = item?.supervisors || [];
            if (!supervisors.length) return <p style={{ color: '#667085' }}>--</p>;
            return (
                <TextRow
                    name={supervisors.map((s) => `${s?.firstName || ''} ${s?.lastName || ''}`).join(', ')}
                    textWidth={8}
                />
            );
        },
    },
    {
        rowText: (item) => getComplianceChip(item?.isCompliant),
    },
];
